import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CoreDeploymentQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICoreDeploymentRun, isRunTerminal } from "../../models/CoreDeployment/CoreDeploymentRun";

/** One run, polled every 10 s while the worker is still moving it along. */
export default function useCoreDeploymentRun(id?: string | null) {
  const { get } = useApiHelper();

  const run = useQuery({
    queryKey: CoreDeploymentQueryKeys.detail(id ?? ""),
    enabled: !!id,
    queryFn: () =>
      get<IDefaultResponse<ICoreDeploymentRun>>(`/core-deployments/${id}`).then(
        (res) => res.data,
      ),
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status && isRunTerminal(status) ? false : 10000;
    },
  });

  return { run };
}
